import axios from './financeiroApi';

const relatorioApi = () => {
  const getPath = () => {
    return `/api/v1/backend/relatorio`;
  };

  return {
    salvarFiltroDre: (filtro) => {
      const url = `${getPath()}/dre/salvar-filtro`;
      return axios.post(url, filtro);
    },
    dreExcel: (parametros, tipoEmissao) => {
      const url = `${getPath()}/dre/excel?tipoEmissao=${tipoEmissao}`;
      return axios.post(url, parametros, {
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    salvarFiltroReceitLancamento: (filtro) => {
      const url = `${getPath()}/receita-lancamento/salvar-filtro`;
      return axios.post(url, filtro);
    },
    salvarFiltroReceitaCliente: (filtro) => {
      const url = `${getPath()}/receita-cliente/salvar-filtro`;
      return axios.post(url, filtro);
    },
    receitaExcel: (parametros) => {
      const url = `${getPath()}/receita-lancamento/excel`;
      return axios.post(url, parametros, {
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    receitaClienteExcel: (parametros, idNotificacao) => {
      const url = `${getPath()}/receita-cliente/excel?idNotificacao=${idNotificacao}`;
      return axios.post(url, parametros, {
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    salvarFiltroDespesaLancamento: (filtro) => {
      const url = `${getPath()}/despesa-lancamento/salvar-filtro`;
      return axios.post(url, filtro);
    },
    salvarFiltroDespesaFornecedor: (filtro) => {
      const url = `${getPath()}/despesa-fornecedor/salvar-filtro`;
      return axios.post(url, filtro);
    },
    despesaExcel: (parametros) => {
      const url = `${getPath()}/despesa-lancamento/excel`;
      return axios.post(url, parametros, {
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    despesaFornecedorExcel: (parametros, idNotificacao) => {
      const url = `${getPath()}/despesa-fornecedor/excel?idNotificacao=${idNotificacao}`;
      return axios.post(url, parametros, {
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    salvarFiltroFluxoDeCaixa: (filtro) => {
      const url = `${getPath()}/fluxo-de-caixa/salvar-filtro`;
      return axios.post(url, filtro);
    },
    fluxoCaixaExcel: (parametros) => {
      const url = `${getPath()}/fluxo-de-caixa/excel`;
      return axios.post(url, parametros, {
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    salvarFiltroBalancete: (filtro) => {
      const url = `${getPath()}/balancete/salvar-filtro`;
      return axios.post(url, filtro);
    },
    balanceteExcel: (parametros) => {
      const url = `${getPath()}/balancete/excel`;
      return axios.post(url, parametros, {
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    salvarFiltroPedidoVenda: (id) => {
      const url = `${getPath()}/pedido-venda/salvar-filtro`;
      return axios.post(url, [id]);
    },
    salvarFiltroBoleto: (filtro) => {
      const url = `${getPath()}/boleto/salvar-filtro`;
      return axios.post(url, filtro);
    },
    salvarFiltroEmitirOrdemServico: (id) => {
      const url = `${getPath()}/emitir-ordem-servico/salvar-filtro`;
      return axios.post(url, [id]);
    },
    salvarFiltroPedidoCompra: (id) => {
      const url = `${getPath()}/pedido-compra/salvar-filtro`;
      return axios.post(url, [id]);
    },
    salvarFiltroExportarPDFEstoque: (search) => {
      const url = `${getPath()}/estoque/salvar-filtro?q=${search}`;
      return axios.post(url);
    },
    estoqueExcel: (search, idNotificacao) => {
      const url = `${getPath()}/estoque/excel?q=${search}&idNotificacao=${idNotificacao}`;
      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    salvarFiltroVisualizarFaturamento: (filtro) => {
      const url = `${getPath()}/faturamento/salvar-filtro`;
      return axios.post(url, [filtro]);
    },
    salvarFiltroGerarRelatorioFaturamentoPDF: (query, mesCompetencia) => {
      const url = `${getPath()}/faturamento/gerar-relatorio?q=${query}&mesCompetencia=${mesCompetencia}`;
      return axios.post(url);
    },
    salvarFiltroEmitirDetalhesBaixaContaPagar: (ids) => {
      const url = `${getPath()}/conta-pagar/salvar-filtro`;
      return axios.post(url, ids);
    },
    salvarFiltroRecibo: (id) => {
      const url = `${getPath()}/recibo/salvar-filtro`;
      return axios.post(url, id);
    },
    salvarFiltroCentroCusto: (filtro) => {
      const url = `${getPath()}/centro-custo/salvar-filtro`;
      return axios.post(url, filtro);
    },
    salvarFiltroCliente: (filtro) => {
      const url = `${getPath()}/cliente/salvar-filtro`;
      return axios.post(url, filtro);
    },
    salvarFiltroVendaDetalhada: (filtro) => {
      const url = `${getPath()}/venda/salvar-filtro`;
      return axios.post(url, filtro);
    },
    vendaDetalhadaExcel: (parametros, idNotificacao) => {
      const url = `${getPath()}/venda-detalhada/excel?idNotificacao=${idNotificacao}`;
      return axios.post(url, parametros, {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    centroCustoExcel: (parametros, idNotificacao) => {
      const url = `${getPath()}/centro-custo/excel?idNotificacao=${idNotificacao}`;
      return axios.post(url, parametros, {
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    clienteExcel: (parametros, idNotificacao) => {
      const url = `${getPath()}/cliente/excel?idNotificacao=${idNotificacao}`;
      return axios.post(url, parametros, {
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    salvarFiltroContratosVigentes: (filtro) => {
      const url = `${getPath()}/contrato/salvar-filtro`;
      return axios.post(url, filtro);
    },
    contratosVigentesExcel: (parametros, idNotificacao) => {
      const url = `${getPath()}/contratos-vigentes/excel?idNotificacao=${idNotificacao}`;
      return axios.post(url, parametros, {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
    buscarTextoPadrao: async (modeloRelatorio) => {
      const url = `${getPath()}/certidao-negativa/texto-padrao?tipoModeloRelatorio=${modeloRelatorio}`;
      return axios({
        url: url,
        method: 'GET',
        responseType: 'text',
      });
    },
    salvarFiltroCertidaoNegativa: (filtro) => {
      const url = `${getPath()}/certidao-negativa/salvar-filtro`;
      return axios.post(url, filtro);
    },
    enviarEmailCertidaoNegativa: (filtro) => {
      const url = `${getPath()}/certidao-negativa/enviar-email`;
      return axios.post(url, filtro);
    },
  };
};

export { relatorioApi };
